import { IContract } from "@river/interfaces";
import { createContext } from "react";

export interface IContractContext {
  contract: IContract | null;
  setContract: (contract: IContract | null) => void;
  fetchContract(): Promise<void>;
}

export const ContractContext = createContext<IContractContext | null>(null);
